(function($) {
    var OfficesMap = function($el, $domains) {
        this.$el = $el;
        this.$domains = $domains;

        this.init();
    };

    OfficesMap.prototype.init = function() {
        this.$markers = this.$el.find('.marker');

        this.map = null;
        this.markersIds = [];
        this.markersCount = 0;

        this.createMap();

        if(this.$domains.length) {
            this.bindEvents();
        }
    };

    OfficesMap.prototype.bindEvents = function() {
        this.$domains.on('mouseenter', this.onDomainOver.bind(this));
        this.$domains.on('mouseleave', this.closeAllInfoWindows.bind(this));
    };

    OfficesMap.prototype.createMap = function() {
        // Create map
        this.map = new google.maps.Map(this.$el[0], {
            zoom        : 3,
            center      : new google.maps.LatLng(28, -70),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#000000"},{"lightness":13}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#144b53"},{"lightness":14},{"weight":1.4}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#08304b"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#0c4152"},{"lightness":5}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"simplified"},{"hue":"#ff0000"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#0b434f"},{"lightness":25}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#0b3d51"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#146474"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#021019"}]}]
        });

        // Add a markers reference
        this.map.markers = [];

        // Add markers
        if(this.$markers.length) {
            var markersInstances = [];

            this.$markers.each(function(index, marker) {
                var markerInstance = this.addMarker($(marker));

                if(markerInstance) {
                    markersInstances.push(markerInstance);
                }
            }.bind(this));

            /*if(markersInstances.length) {
                var markersCluster = new MarkerClusterer(this.map, markersInstances, {
                    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                    maxZoom: 11,
                    zoomOnClick: true,
                    averageCenter: true,
                });
            }*/
        }

        this.centerMap();
    };

    OfficesMap.prototype.addMarker = function($marker) {
        var id = $marker.attr('data-marker-id');
        var icon = $marker.attr('data-icon');
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        var marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
            icon: icon
        });

        if(!id) {
            id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        }

        if(!this.map.markers[id]) {
            // Add to marker to markers array
            this.map.markers[id] = marker;

            // If marker contains HTML, add it to an infoWindow
            if($marker.html()) {
                // Create info window
                marker.infowindow = new google.maps.InfoWindow({
                    content: $marker.html(),
                    pixelOffset: new google.maps.Size(250,150)
                });

                // Show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', this.onMarkerClick.bind(this, marker));
            }

            this.markersCount ++;
            this.markersIds.push(id);

            return marker;
        }

        return false;
    };

    OfficesMap.prototype.onDomainOver = function(e) {
        var $target = $(e.currentTarget);

        if($target && $target[0].hasAttribute('data-marker-id')) {
            var id = $target.attr('data-marker-id');

            this.focusMarker(id);
        }
        else {
            this.centerMap();
        }
    };

    OfficesMap.prototype.onMarkerClick = function(marker) {
        this.closeAllInfoWindows();

        if(marker.infowindow) {
            marker.infowindow.open(this.map, marker);
        }
    };

    OfficesMap.prototype.focusMarker = function(id) {
        if(this.map.markers[id]) {
            this.closeAllInfoWindows();
            this.map.setZoom(3);
            var marker = this.map.markers[id];
            var markerPos = marker.getPosition();
            // var newPos = new google.maps.LatLng(pt.lat() + .02, pt.lng());
            var newPos = new google.maps.LatLng(markerPos.lat(), markerPos.lng());
            this.map.panTo(markerPos);
            marker.infowindow.open(this.map, marker);
        }
    };

    OfficesMap.prototype.closeAllInfoWindows = function() {
        this.markersIds.forEach(function(markerId) {
            var marker = this.map.markers[markerId];

            if(marker.infowindow) {
                marker.infowindow.close();
            }
        }.bind(this));
    };

    OfficesMap.prototype.centerMap = function() {
        var bounds = new google.maps.LatLngBounds();

        // Loop through all markers and create bounds
        this.markersIds.forEach(function(markerId) {
            var marker = this.map.markers[markerId];
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            bounds.extend(latlng);
        }.bind(this));

        // Only 1 marker?
        if(this.markersCount == 1) {
            // Set center of map
            this.map.setCenter(bounds.getCenter());
            this.map.setZoom(4);
        }
        else {
            // Fit to bounds
            this.map.fitBounds(bounds);
        }
    };

    $(document).ready(function(){
        $('.contact-page').each(function() {
            var $this = $(this);
            var $map = $this.find('.contact-col-right');
            var $domains = $this.find('.list-offices__item');

            if($map.length) {
               var instance = new OfficesMap($map, $domains);
            }
        });
    });

})(jQuery);
